interface ActivityContextProps {
  text: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export function ActivityContext(props: ActivityContextProps) {
  const { text, disabled = false, onClick } = props;
  if (!text) return null;
  return (
    <div
      onClick={!disabled ? onClick : undefined}
      className="flex w-full p-3 items-center gap-4 self-stretch rounded bg-neutral-50 mt-2"
    >
      <div className="flex justify-center items-start gap-2 self-stretch ">
        <div className="w-full text-neutral-800 text-sm	flex items-start">{text}</div>
      </div>
    </div>
  );
}
